import {IQuote} from "../Common/IQuote";
import {IApplicationQuote} from "../Application/IApplicationQuote";

export type IndirectQuoteFieldType = number | undefined | string | null;
export type IndirectOnChangeFunction = (columnConfig: IndirectQuoterColumnConfig, fieldName: keyof IQuote, value?: IndirectQuoteFieldType) => void;

export interface IndirectQuoterColumnConfig {
  columnTitle: string;
  editableApplicationQuote?: IApplicationQuote; // Mainly used as a reference for the quote that is being worked
  recommendedApplicationQuote?: IApplicationQuote; // Mainly used as a reference for the recommended quote
  fieldConfigs: IndirectQuoterFieldConfig[];
  hideAllRecommendedValues: boolean;
}

export interface IndirectQuoterFieldConfig {
  fieldLabel: IndirectQuoterFieldLabel; // Title for the column
  fieldLabelAddOn?: string; // Gets added onto the end of the label with a space between
  fieldName?: keyof IQuote; // Used for updating the quote
  value: IndirectQuoteFieldType;
  recommendedValue?: IndirectQuoteFieldType;
  disableInput: boolean;
  hideRecommendation: boolean;
  lookups?: {
    values: object[] | undefined,
    idField: string,
    descriptionField: string
  };
  errorMessage?: string;
  showErrorSpacing?: boolean;
  inputType: IndirectQuoterInputType;
  min?: number; // Lowest value the numeric input accepts; typed values below it are clamped up
}

export enum IndirectQuoterInputType {
  Text = 0,
  Percentage = 1,
  Integer = 2,
  Currency = 3,
  Dropdown = 4
}

export type IndirectQuoterFieldLabel =
  "Transaction Type"
  | "Pricing Program"
  | "Sale Price"
  | "Bookout"
  | "Cash Down"
  | "Deferred Down"
  | "Rebate"
  // | "Trade Allowance"
  // | "Trade Lien"
  | "Net Trade"
  // Front End Fees
  | "Taxes"
  | "Front End Fees"
  | "TT&L"
  | "Unpaid Balance"
  
  // Back End Fees
  | "Service Warranty"
  | "GAP"
  | "Credit Life"
  | "Disability / AH"
  | "Other Back End Fees"
  
  | "Amount to Finance"
  | "Pay Type"
  | "Term (months)"
  | "Balloon Term (months)"
  | "APR"
  | "Payment"
  | "Balloon Payment"
  | "Front End LTV"
  | "Front End LTV After Dealer Partial"
  | "Total LTV"
  
  // Dealer Check
  | "Acquisition Fee"
  | "Other Lender Fees"
  | "Discount %"
  | "Discount $"
  | "Dealer Partial"
  | "Dealer Reserve"
  | "Dealer Reserve Override"
  | "Commission"
  | "Dealer Check";